import {Model} from './model.class';
import {Service} from './service.class';
import {Observable} from 'rxjs';
import {Response} from '@angular/http';
import {IdentifiedModelListService} from './identified-model-list.service';
import {IdentifiedModel} from './identified-model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class UserIdentifiedModelListService<T extends IdentifiedModel<T>> {

    private _modelService: IdentifiedModelListService<T>;
    changes$: Observable<boolean>;

    constructor(svcm: Service.InjectedMembers, namespace: string, protected readonly _modelType: Model.Type<T>) {
        this._modelService = new IdentifiedModelListService(svcm, namespace, _modelType, 'currentUser');
        this.changes$ = this._modelService.changes$;
    }

    getCurrentUserModelEntryList(projection?: ProjectionInformation): Observable<Array<T>> {
        return this._modelService.getCurrentUserModelEntryList(projection);
    }

    updateCurrentUserModelEntry(model: T): Observable<Response> {
        return this._modelService.updateCurrentUserModelEntry(model);
    }

    deleteCurrentUserModelEntry(model: T): Observable<Response> {
        return this._modelService.deleteCurrentUserModelEntry(model);
    }

    countCurrentUserModelEntries(): Observable<number> {
        return this._modelService.countCurrentUserModelEntries();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/user-identified-model-list.service.ts